import { TENANT_ID } from 'global/constants';

import { objGetProp } from './objectUtils';
import { GRIDNET_PROVIDER, getTenantId } from './tenantUtil';

export const parseAEMDatapolicyProps = (props) => {
  switch (getTenantId()) {
    case TENANT_ID.EDI:
      return [{ link: props.datapolicyEDILink, label: props.datapolicyEDILabel }];
    case TENANT_ID.SHNG:
      return [
        { link: props.datapolicySHNGLink, label: props.datapolicySHNGLabel },
        { link: props.datapolicyEENGLink, label: props.datapolicyEENGLabel },
        { link: props.datapolicyHANSGLink, label: props.datapolicyHANSGLabel },
        { link: props.datapolicyNNNGLink, label: props.datapolicyNNNGLabel },
      ];
    case TENANT_ID.AVA:
      return [{ link: props.datapolicyAVALink, label: props.datapolicyAVALabel }];
    case TENANT_ID.BAG:
      return [{ link: props.datapolicyBAGLink, label: props.datapolicyBAGLabel }];
    case TENANT_ID.MTN:
      return [{ link: props.datapolicyMTNLink, label: props.datapolicyMTNLabel }];
    case TENANT_ID.LVN:
      return [{ link: props.datapolicyLVNLink, label: props.datapolicyLVNLabel }];
    default:
      return [];
  }
};
export const parseAEMDataPolicySHNGProps = (props) => {
  if (getTenantId() === TENANT_ID.SHNG) {
    return [
      { link: props.datapolicyZVEHLink, label: props.datapolicyZVEHLabel },
      { link: props.datapolicyVIULink, label: props.datapolicyVIULabel },
      { link: props.datapolicyTABLink, label: props.datapolicyTABLabel },
    ];
  }
  return [];
};
export const parseAEMSelfDeclarationCompanyFacilityProps = (props) => {
  if (getTenantId() === TENANT_ID.SHNG) {
    return [props.selfDeclarationCompanyFacilityLink, props.selfDeclarationCompanyFacilityNNNGLink];
  }
  if (getTenantId() === TENANT_ID.MTN) {
    return [
      props.selfDeclarationCompanyFacilityLinkMTNEnergy,
      props.selfDeclarationCompanyFacilityLinkMTNGas,
    ];
  }
  return props.selfDeclarationCompanyFacilityLink;
};

export const parseAEMInstallerContractProps = (props, installer) => {
  let link = props.installerContractLink;
  switch (getTenantId()) {
    case TENANT_ID.SHNG:
      if (installer && installer.b_netzbetreiber_gas) {
        switch (installer.b_netzbetreiber_gas.id) {
          case GRIDNET_PROVIDER.SHNG.EENG:
            link = props.installerContractLinkEENGLink;
            break;
          case GRIDNET_PROVIDER.SHNG.HANSG:
            link = props.installerContractLinkHANSGLink;
            break;
          case GRIDNET_PROVIDER.SHNG.NNNG:
            link = props.installerContractLinkNNNGLink;
            break;
          default:
            break;
        }
      }
      break;
    default:
      break;
  }
  return link;
};

export const parseTrainingCertificateExtensionLink = (props) =>
  props.trainingCertificateExtensionLink;

export const getMetaNavLinks = (props) => {
  let result = [];
  const links = objGetProp(props, 'metaNav.links');

  if (links) {
    result = [...links];
  }

  return result;
};

export const getFooterLinks = (props) => {
  const navRoot = props.navigation?.items?.length ? props.navigation.items[0] : [];
  const navLinks = [
    {
      title: navRoot?.title,
      url: navRoot?.url,
    },
    ...(navRoot?.children || []),
  ];

  return navRoot ? navLinks : [];
};
